<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import CampaignPlanForm from './CampaignPlanForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaignPlan = async planDetails => {
  try {
    await store.dispatch('campaignPlans/create', planDetails);
    useAlert(t('CAMPAIGN_PLANS.CREATE.SUCCESS'));
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      t('CAMPAIGN_PLANS.CREATE.ERROR');
    useAlert(errorMessage);
  }
};

const handleSubmit = planDetails => {
  addCampaignPlan(planDetails);
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[22rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[80vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12 flex-shrink-0">
        {{ t('CAMPAIGN_PLANS.CREATE.TITLE') }}
      </h3>
      <CampaignPlanForm @submit="handleSubmit" @cancel="handleClose" />
    </div>
  </div>
</template>

